import React from "react";
import { Helmet } from "react-helmet-async";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQSection({ faqs, title = "Frequently Asked Questions", eyebrow = "FAQ", intro }) {
  if (!faqs || faqs.length === 0) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section data-testid="faq-section" aria-label="Frequently asked questions" className="py-24 bg-[#faf7f2]/40 border-y border-[#e5ddd0]">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#b08d57] mb-4">{eyebrow}</div>
        <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#1a1a1a] mb-4">{title}</h2>
        {intro ? <p className="text-[#6b6b6b] text-lg leading-relaxed mb-8">{intro}</p> : <div className="mb-8" />}
        <Accordion type="single" collapsible className="border-t border-[#e5ddd0]">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-b border-[#e5ddd0]">
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="text-left font-display text-lg font-semibold text-[#1a1a1a] hover:text-[#b08d57] hover:no-underline py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${i}`} className="text-[#4a4a4a] text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
